import { render, staticRenderFns } from "./TransboundaryRecord.vue?vue&type=template&id=d6f9c11a&scoped=true"
import script from "./TransboundaryRecord.vue?vue&type=script&lang=js"
export * from "./TransboundaryRecord.vue?vue&type=script&lang=js"
import style0 from "./TransboundaryRecord.vue?vue&type=style&index=0&id=d6f9c11a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f9c11a",
  null
  
)

export default component.exports